import LazyLoading from './common/lazyLoading';
import LoadPurchase from './common/loadPurchase.js';
import LoadSpeechSearch from './components/loadSpeechSearch.js';
import CartDrawer from './common/cartDrawer';
import Footer from './common/footer';
import Header from './common/header';
import Webforms from './common/webforms';
import Price from './components/price/price.js';
import { NewsletterComponent } from './components/vndaComponents.js';
import { setSearch } from './components/utilities';

// ==========================================
// Inicialização
// ==========================================
console.log(
  '%cOlist - Soluções de vendas online e Serviços de E-commerce',
  'color: #0a4ee4; font-size: 14px; font-family: "Verdana", sans-serif; font-weight: bold;'
);

window.addEventListener('DOMContentLoaded', () => {
  Header.init();
  Price.init();
  LazyLoading.init();
  LoadPurchase.init();
  LoadSpeechSearch.init()
  CartDrawer.init();
  Footer.init();
  Webforms.init();
  NewsletterComponent.init();
  setSearch();
});



document.addEventListener('DOMContentLoaded', function() {
    // Elemento mais específico - pega o link com href="#sobre" dentro de .first-column
    const saibaMaisLink = document.querySelector('.first-column a[href="#sobre"]');
    const popup = document.getElementById('popupSobre');
    const closeBtn = document.querySelector('.close-btn');

    // Abrir popup ao clicar no link
    saibaMaisLink.addEventListener('click', function(e) {
        e.preventDefault();
        popup.style.display = 'block';
    });

    // Fechar popup ao clicar no X
    closeBtn.addEventListener('click', function() {
        popup.style.display = 'none';
    });

    // Fechar popup ao clicar fora do conteúdo
    popup.addEventListener('click', function(e) {
        if (e.target === popup) {
            popup.style.display = 'none';
        }
    });

    // Fechar popup com a tecla ESC
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popup.style.display === 'block') {
            popup.style.display = 'none';
        }
    });
});